import { useMutation } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { useAuthSignIn } from '../../../hooks/useSignIn';
import { setSurferWelcomePending } from '../../../constants';
import { authApi } from '../../authApi';
import type { VerifiedSurferRegistrationRequest } from '../../types';

export const useVerifiedSurferRegister = () => {
  const signIn = useAuthSignIn();
  return useMutation({
    mutationKey: [MutationKey.AUTH_SURFER_REGISTER_VERIFIED],
    mutationFn: (payload: VerifiedSurferRegistrationRequest) =>
      authApi.surferRegisterVerified(payload),
    onSuccess: ({ data, meta }) => {
      setSurferWelcomePending();
      signIn({
        tokenExpiresIn: data.expiresIn,
        token: data.accessToken,
        tokenType: data.tokenType,
        refreshToken: data.refreshToken,
        ...meta.user,
      });
    },
  });
};
